module.exports = __webpack_public_path__ + "img/f_logo_RGB-Hex-Blue_512.d133b91c.png";